import { Constants } from '../utils/constants';

/**
 * 10Gアップグレードの紐づけ（リンク）状態を判定する
 * STSのリンク状態をもとに、紐づけ済み（LINKOK）または未紐づけ（LINKNG）を返す。
 *
 * @param link_state STSから取得したリンク状態
 * @returns リンク状態の判定結果定数
 */
export const judgeLink = (link_state: string) => {
  const stsupgrade = link_state;

  if (stsupgrade) {
    // 紐づけ済みの場合
    if (stsupgrade === Constants.UpgradelinkstateSTS.link) {
      return Constants.LINK.LINKOK;
    }
    // 未紐づけの場合
    if (stsupgrade === Constants.UpgradelinkstateSTS.NOTlink) {
      return Constants.LINK.LINKNG;
    }
  }
  // 状態が未設定の場合は未紐づけとして扱う
  return Constants.LINK.LINKNG;
};

export default judgeLink;
